import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  { title: "Cloud Strategy & Adoption", description: "Crafting bespoke cloud roadmaps and facilitating seamless migration and adoption for enterprise-level clients." },
  { title: "AI & Machine Learning", description: "Leveraging cutting-edge AI and ML to unlock data-driven insights and automate complex business processes." },
  { title: "DevOps & CI/CD", description: "Streamlining development pipelines with robust automation, continuous integration, and delivery practices." },
  { title: "Data Analytics & Insights", description: "Transforming raw data into actionable intelligence with advanced analytics and visualization." },
  { title: "Enterprise Security", description: "Implementing comprehensive security protocols and compliance measures to protect your digital assets." },
  { title: "API Platform Services", description: "Building scalable and secure API platforms to power your digital ecosystem and connect services." },
];

const cloudLogos = [
  { name: "AWS", path: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" },
  { name: "Azure", path: "https://upload.wikimedia.org/wikipedia/commons/a/a8/Microsoft_Azure_Logo.svg" },
  { name: "Google Cloud", path: "https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg" },
  { name: "Oracle Cloud", path: "https://1000logos.net/wp-content/uploads/2024/08/Oracle-Cloud-Logo.png" },
  { name: "IBM Cloud", path: "https://upload.wikimedia.org/wikipedia/commons/2/24/IBM_Cloud_logo.png" },
];

const HomePage = () => {
  return (
    <>
      {/* Hero Section */}
      <main className="px-8 py-24 text-center animate-fadeIn">
        <h1 className="text-6xl md:text-8xl font-bold mb-4">
          Engineering the Future of
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-secondary">
            Cloud & AI
          </span>
        </h1>
        <p className="text-xl md:text-2xl text-brand-text-dark max-w-3xl mx-auto mb-10">
          We architect and build scalable, intelligent systems that power the world's most innovative companies.
        </p>
        <Link to="/services">
          <button className="bg-brand-primary hover:bg-opacity-80 text-white font-bold py-4 px-10 rounded-lg text-lg transition-transform transform hover:scale-105">
            Explore Our Services
          </button>
        </Link>
      </main>

      {/* Cloud Services Logos */}
      <div className="py-16 bg-brand-gray">
        <div className="container mx-auto">
          <p className="text-center text-brand-text-dark mb-10 text-lg font-semibold tracking-wider uppercase">POWERING OUR SOLUTIONS WITH WORLD-CLASS CLOUD PLATFORMS</p>
          <div className="flex justify-center items-center gap-x-12 gap-y-8 flex-wrap">
            {cloudLogos.map(logo => (
              <img key={logo.name} src={logo.path} alt={logo.name} className="h-10 md:h-12 object-contain" />
            ))}
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section id="services" className="px-8 py-20">
        <h2 className="text-5xl font-bold text-center mb-4">Core Services</h2>
        <p className="text-xl text-center text-brand-text-dark max-w-2xl mx-auto mb-16">
          We provide a comprehensive suite of services to guide your digital transformation journey from start to finish.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-brand-gray p-8 rounded-xl border border-brand-light-gray hover:border-brand-primary transition-all duration-300 transform hover:-translate-y-2">
              <h3 className="text-2xl font-bold mb-3">{service.title}</h3>
              <p className="text-brand-text-dark">{service.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HomePage; 